import runtimeEnv from "@mars/heroku-js-runtime-env";

const env = runtimeEnv();

export const FORCE_ECOSYSTEM_USER_CREATION =
  env.REACT_APP_FORCE_ECOSYSTEM_USER_CREATION === "true";
